<template>
    <div class="body_tag" :class="{ 'fixed-left-void': !isMainMenuOpen, 'fixed-left': isMainMenuOpen }">

        <!-- Begin page -->
        <div id="wrapper" :class="{ 'menu_show': !isMainMenuOpen }">

            <!-- Header -->
            <pml-header></pml-header>

            <!-- Main Menu -->
            <pml-main-menu></pml-main-menu>

            <!-- Content -->
            <div class="content-page">
                <div class="content">
                    <div class="container" data-step="9">
                        <slot></slot>
                    </div>
                </div>
            </div>
            <!-- End Content -->

        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { isEmpty } from 'lodash'

    export default {
        name: 'MasterLayout',
        computed: {
            ...mapGetters({
                isMainMenuOpen: 'getIsMainMenuOpen'
            })
        },
        created () {
            this.checkToken()
        },
        methods: {
            ...mapActions(['logout']),
            checkToken () {
                if (isEmpty(window.localStorage.getItem('pml_token'))) {
                    if (typeof this.$ma !== 'undefined') this.$ma.reset()
                    this.logout()
                        .then(() => {
                            this.$router.push({name: 'auth.login'})
                        })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layouts/Master.vue